module.exports = __webpack_public_path__ + "static/gamer.c1cf3c51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gamer.svg
// module id = 148
// module chunks = 35783957827783 95715928098905 172322841747965